import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/product';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section id="faq" className="border-b border-white/10 bg-ink-900" data-id="element-189" data-mp="1bmvd2wg8u6qp">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-190" data-mp="1gk59wx5ypkok">
        <h2 className="grit-headline text-[clamp(2.25rem,8vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-191" data-mp="24a94yg534c3y">
          Straight <span className="text-grit-500" data-id="element-192" data-mp="28a9ogf71jdhv">answers.</span>
        </h2>

        <ul className="mt-8 max-w-3xl border-t border-white/10" data-id="element-193" data-mp="1uk6824uuee0c">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} className="border-b border-white/10" data-id="element-194" data-mp="2n8bwb1l3ul4x" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? -1 : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-5 py-5 text-left text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-195" data-mp="2n5z6615714gs">
                  <span className="font-display text-xl font-bold uppercase leading-tight sm:text-2xl" data-id="element-196" data-mp="19udgvi8mj3ac">{faq.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-197" data-mp="1ohyfozygugcg" /> : <PlusIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-198" data-mp="1jjx22ujt798d" />}
                </button>
                <AnimatePresence initial={false} data-id="element-199" data-mp="1sl4mq9tekbjz">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-200" data-mp="1sj1tzi0v84bk">
                      <p className="max-w-2xl pb-6 text-[15px] leading-relaxed text-steel-400" data-id="element-201" data-mp="238pw0th40kkq">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}